<lds-card margin="none">
  <div class="activity">

    <!-- activity / header -->
    <div class="activity__header">
      <div class="activity__header-icon">
        <lds-icon name="analytics" size="md"></lds-icon>
      </div>
      <div class="activity__header-text">
        <h4>Lending Summary</h4>
        <p>Your lending activity and insights</p>
      </div>
    </div>

    <!-- activity / content -->
    <div class="activity__content">
      <div class="row">
        <div class="col-12 col-md-8 col-xl-7">

          <!-- data visualization -->
          <div class="activity__graph">
            <!--TODO: replace with data visualization library [future release]-->
            <img class="image image--responsive" src="assets/images/lending-activity-graph.jpg" alt="lending activity and insights" />
          </div>

        </div>
        <div class="col-12 col-md-4 col-xl-5 mt-4 mt-md-0 my-xl-auto">

          <!-- loan type insights -->
          <ul class="activity-insights">
            <ng-container *ngFor="let activity of activities$ | async">

              <lds-tooltip cursor="help" message="{{ activity.value || 0 | plural: activity.title }}">
                <li class="activity-insights__item">
                  <div class="activity-insights__item-value">
                    {{ activity.value }}
                  </div>
                  <div class="activity-insights__item-icon">
                    <lds-icon [name]="activity.icon" size="sm"></lds-icon>
                  </div>
                </li>
              </lds-tooltip>

            </ng-container>
          </ul>

        </div>
      </div>
    </div>

  </div>
</lds-card>
